import React from "react";

const Switch = ({
  value,
  onChange,
  style = {},
  className = "",
  disabled,
  name
}) => {
  return (
    <label className={["switch"].concat(className.split(",")).join(" ")}>
      <input
        type="checkbox"
        name="switch_1"
        value="0"
        checked={value}
        onChange={() => {
          onChange(name, !value);
        }}
        disabled={disabled}
      />
      <span />
    </label>
  );
};

export default Switch;



// WEBPACK FOOTER //
// ./src/_components/UI/Switch/index.js